// @jadwalh/axios/index.ts

import axios from 'axios';
import { toast } from 'react-toastify';

const instance = axios.create({ baseURL: import.meta.env.VITE_BASE_URL });

instance.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  config.headers['Access-Control-Allow-Credentials'] = 'true';
  config.headers['Access-Control-Allow-Origin'] = '*';
  config.headers['Accept-Language'] = localStorage.getItem('lang');
  return config;
});

// Error handling for the Axios instance
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    switch (error?.response?.status) {
      case 400:
        toast.error(error.response.data.message);
        break;
      case 401:
        toast.error(error.response.data.message);
        location.href = '/login';
        localStorage.removeItem('token');
        break;
      case 404:
        toast.error(error.response.data.message);
        location.href = '/404';
        break;
      case 500:
        toast.error('something went wrong');
        location.href = '/error';
        break;
      default:
        toast.error(error?.response?.data?.message);
        break;
    }
    return Promise.reject(error);
  }
);

export default instance;
